export const items = {
    "france": {
        "name": 'france',
        "title": 'Франция',
        'img': '/static/images/maps/france.jpg',
        'img_mobile': '/static/images/maps_mobile/france.jpg',
        "items": [
            {
                "id": 1,
                "name": "Эйфелева башня",
                "text": "Самую узнаваемую архитектурную достопримечательность Парижа фотографируют все, но мало кто — хорошо. Если нет возможности остановиться в одном из окрестных дорогих отелей, чьи террасы выходят на башню, попробуйте снять ее с узкой улицы Юниверсите, которая подходит к Марсову полю с западной стороны. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": "Париж",
                "img": "/static/images/places/france/france5.jpg",
                "img_mobile": "/static/images/places_mobile/france/france5.jpg",
                "isActive": false,
                "position": {
                    'left': '15.8em',
                    'top': '19.1em'
                },
                "position_mobile": {
                    'left': '11em',
                    'top': '20em'
                }
            },
            {
                "id": 2,
                "name": "Аббатство Мон-Сен-Мишель",
                "text": "Мон-Сен-Мишель — самое посещаемое место во Франции после Парижа. Аббатство на скале со всех сторон защищено морем, известным своими приливами: перепад между самым высоким и самым низким уровнями воды достигает здесь рекордной величины 15 метров. Остров с материком соединяет только дамба длиной в 2 километра — лучшие фотографии аббатства сняты отсюда. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": "Манш",
                "img": "/static/images/places/france/france1.jpg",
                "img_mobile": "/static/images/places_mobile/france/france1.jpg",
                "isActive": true,
                "position": {
                    'left': '7.3em',
                    'top': '17.5em'
                },
                "position_mobile": {
                    'left': '3.8em',
                    'top': '18.8em'
                }
            },
            {
                "id": 3,
                "name": "Набережная Променад-дез-Англе",
                "text": "Променад-дез-Англе, или Английская набережная, — один из символов Лазурного Берега. Жизнь здесь не утихает ни днем, ни ночью: с одной стороны мерно гудят рестораны и лобби-бары самых роскошных отелей Ниццы, с другой — течет бесконечный поток туристов, выглядывающих в море яхты европейских знаменитостей. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": "Ницца",
                "img": "/static/images/places/france/france3.jpg",
                "img_mobile": "/static/images/places_mobile/france/france3.jpg",
                "isActive": false,
                "position": {
                    'left': '27.6em',
                    'top': '39.2em'
                },
                "position_mobile": {
                    'left': '20.9em',
                    'top': '34.4em'
                }
            },
            {
                "id": 4,
                "name": "Национальный парк Каланки",
                "text": "Каланки — гордость Франции и важный туристический аттракцион, те же фьорды, то есть глубокие и узкие заливы со скалистыми берегами, только средиземноморские. Посмотреть их можно с моря и с суши, но второй вариант лучше: море между Кассисом и Марселем часто бывает неспокойным, и владельцы экскурсионных катеров часто сворачивают осмотр после первого же каланка. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": "Марсель",
                "img": "/static/images/places/france/france4.jpg",
                "img_mobile": "/static/images/places_mobile/france/france4.jpg",
                "isActive": false,
                "position": {
                    'left': '22.8em',
                    'top': '41em'
                },
                "position_mobile": {
                    'left': '17em',
                    'top': '35.5em'
                }
            },
            {
                "id":5,
                "name": "Дом и сады Клода Моне",
                "text": "В Живерни, где Клод Моне жил с 1883 года до самой смерти, приезжают не только поклонники его творчества, но и ценители ландшафтного искусства: восстановленный сад перед домом художника цветет с ранней весны до поздней осени. А знаменитый Японский мост, который Моне писал в своей серии с кувшинками, хорош в любое время года — изящная конструкция, застывшая между небом и водой. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": "Живерни",
                "img": "/static/images/places/france/france2.jpg",
                "img_mobile": "/static/images/places_mobile/france/france2.jpg",
                "isActive": false,
                "position": {
                    'left': '13.8em',
                    'top': '17.8em'
                },
                "position_mobile": {
                    'left': '9.6em',
                    'top': '19.4em'
                }
            },
        ]
    },
    "spain": {
        "name": "spain",
        "title": 'Испания',
        'img': '/static/images/maps/spain.jpg',
        'img_mobile': '/static/images/maps_mobile/spain.jpg',
        "items": [
            {
                "id": 1,
                "name": "Саграда-Фамилия",
                "text": "Храм Святого Семейства, лишь часть которого была построена при жизни его главного архитектора Антонио Гауди, до сих пор не завершен — тем интереснее год за годом приезжать в Барселону и замечать новые детали, снимая собор с разных ракурсов. ",
                "description": "Неожиданный снимок можно сделать внутри, если встать между колоннами, распределяющими вес башен и сводов: по мере приближения к потолку они разветвляются, создавая удивительную конструкцию в виде леса. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Барселона',
                "img": "/static/images/places/spain/spain3.jpg",
                "img_mobile": "/static/images/places_mobile/spain/spain3.jpg",
                "isActive": false,
                "position": {
                    'left': '27em',
                    'top': '21.8em'
                },
                "position_mobile": {
                    'left': '20.4em',
                    'top': '22em'
                }
            },
            {
                "id": 2,
                "name": "Улица Гран Виа",
                "text": "Главный мадридский променад: самые породистые особняки, исторические бары и модные магазины находятся здесь. Равно как и первый испанский небоскреб — штаб-квартира национальной телефонной компании Telefónica, построенная в 1930-х. Во время войны на ее крыше работал наблюдательный пункт сил противовоздушной обороны, сегодня — обзорная площадка, откуда можно сделать отличные фотографии испанской столицы. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Мадрид',
                "img": "/static/images/places/spain/spain4.jpg",
                "img_mobile": "/static/images/places_mobile/spain/spain4.jpg",
                "isActive": false,
                "position": {
                    'left': '13.4em',
                    'top': '25.4em'
                },
                "position_mobile": {
                    'left': '9em',
                    'top': '24.5em'
                }
            },
            {
                "id": 3,
                "name": "Набережная Оньяр",
                "text": "Знаменитый жилой квартал на реке Оньяр выглядит ярко и свежо, несмотря на речную влажность и почтенный возраст: дома, нависающие над водой, построили еще в XVII веке на месте крепостной стены. ",
                "description": "Классический кадр — плотная оранжевая застройка и ее отражение в темной речной воде — ждет вас на противоположной стороне Оньяр.",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Жирона',
                "img": "/static/images/places/spain/spain2.jpg",
                "img_mobile": "/static/images/places_mobile/spain/spain2.jpg",
                "isActive": false,
                "position": {
                    'left': '28.6em',
                    'top': '20em'
                },
                "position_mobile": {
                    'left': '21.8em',
                    'top': '20.9em'
                }
            },
            {
                "id": 4,
                "name": "Альгамбра",
                "text": "Бывшая резиденция мусульманских правителей Гранады —самый важный памятник мавританского искусства в Испании, а также настоящий заповедник для фотографов, которые снимают архитектуру. Особенно парадный вид имеет Миртовый дворик — элегантное патио с мраморным водоемом, ажурными арками и миртовой изгородью, давшей название месту. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Гранада',
                "img": "/static/images/places/spain/spain1.jpg",
                "img_mobile": "/static/images/places_mobile/spain/spain1.jpg",
                "isActive": true,
                "position": {
                    'left': '13.4em',
                    'top': '36.1em'
                },
                "position_mobile": {
                    'left': '9em',
                    'top': '32.3em'
                }
            },
            {
                "id": 5,
                "name": "Сансет Стрип",
                "text": "Название не врет: главный аттракцион улицы Сансет-стрип, протянувшейся вдоль набережной курорта Сан-Антонио, — морские закаты. По этой причине большинство здешних ресторанов и кафе, в том числе знаменитое Café del Mar, открываются ближе к вечеру, а днем собирают силы перед наплывом туристов. ",
                "description": "Если хотите увидеть лучший природный спектакль Ибицы с выгодной точки, бронируйте столик заранее. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Ибица',
                "img": "/static/images/places/spain/spain5.jpg",
                "img_mobile": "/static/images/places_mobile/spain/spain5.jpg",
                "isActive": false,
                "position": {
                    'left': '25.2em',
                    'top': '30.3em'
                },
                "position_mobile": {
                    'left': '18.8em',
                    'top': '28em'
                }
            }
        ]
    },
    "italy": {
        "name": "italy",
        "title": 'Италия',
        'img': '/static/images/maps/italy.jpg',
        'img_mobile': '/static/images/maps_mobile/italy.jpg',
        "items": [
            {
                "id": 1,
                "name": "Колизей",
                "text": "Снимать главную римскую достопримечательность непросто — то полфасада в лесах, то огромные толпы туристов, вооруженных селфи-стиками, заслоняют вид. Впрочем, толкаться у амфитеатра в надежде на зазор между чужими телефонами совершенно необязательно: лучшая смотровая площадка, откуда удобно фотографировать Колизей целиком, — пешеходный мостик над улицей Аннибальди, — находится недалеко от входа на станцию метро Colosseo.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Рим',
                "img": "/static/images/places/italy/italy3.jpg",
                "img_mobile": "/static/images/places_mobile/italy/italy3.jpg",
                "isActive": false,
                "position": {
                    'left': '17.7em',
                    'top': '27.6em'
                },
                "position_mobile": {
                    'left': '12.6em',
                    'top': '26em'
                }
            },
            {
                "id": 2,
                "name": "Галерея Виктора Эммануила 2",
                "text": "Один из старейших пассажей мира соединяет Дуомскую площадь с пьяццей перед театром Ла Скала. Это настоящее произведение искусства: галерея, спроектированная в форме креста, укрыта куполом из стекла и железа и украшена мозаиками и барельефами.",
                "description": "Снимать последние лучше всего с балкона в кафе отеля TownHouse Galleria, который находится внутри самой галереи.",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Милан',
                "img": "/static/images/places/italy/italy2.jpg",
                "img_mobile": "/static/images/places_mobile/italy/italy2.jpg",
                "isActive": false,
                "position": {
                    'left': '8.5em',
                    'top': '12em'
                },
                "position_mobile": {
                    'left': '5.1em',
                    'top': '14.7em'
                }
            },
            {
                "id": 3,
                "name": "Остров Бурано",
                "text": "Бурано — самый красивый остров в Венецианской лагуне: все его двух- и трехэтажные дома выкрашены в сочные цвета, которые не повторяются в пределах улицы. Даже осенью и зимой, когда залив затягивает мокрым туманом, буранские постройки выглядят ярко — как вживую, так и на фотографиях.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Венеция',
                "img": "/static/images/places/italy/italy4.jpg",
                "img_mobile": "/static/images/places_mobile/italy/italy4.jpg",
                "isActive": false,
                "position": {
                    'left': '17.5em',
                    'top': '12em'
                },
                "position_mobile": {
                    'left': '12.3em',
                    'top': '14.8em'
                }
            },
            {
                "id": 4,
                "name": "Церковь Сан-Бьяджо",
                "text": "Мадонна-ди-Сан-Бьяджо, небольшая церковь на въезде в тосканский Монтепульчано, считается эталоном архитектуры Высокого Возрождения. Стоит она за пределами городских стен, у подножия холма, поэтому фотографировать ее лучше всего с улицы Сан-Бьяджо, которая круто скатывается к церкви с горы: если снимать отсюда, кроме постройки в кадр попадет красивая оливковая роща. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Монтепульчано',
                "img": "/static/images/places/italy/italy5.jpg",
                "img_mobile": "/static/images/places_mobile/italy/italy5.jpg",
                "isActive": false,
                "position": {
                    'left': '16em',
                    'top': '21.8em'
                },
                "position_mobile": {
                    'left': '11.4em',
                    'top': '22em'
                }
            },
            {
                "id": 5,
                "name": "Вилла Руфоло",
                "text": "В Средневековье небольшой городок у Салернского залива стал местом, где знатные амальфитанские семьи, спасаясь от летней жары, возводили великолепные виллы. Та, что принадлежала семейству Руфоло, со временем стала символом Равелло — и любимой достопримечательностью фотографов: с тридцатиметровой башни Торре-Маджоре прекрасно «простреливается» бирюзовый залив и окрестные горы.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Равелло',
                "img": "/static/images/places/italy/italy1.jpg",
                "img_mobile": "/static/images/places_mobile/italy/italy1.jpg",
                "isActive": true,
                "position": {
                    'left': '23.4em',
                    'top': '32.7em'
                },
                "position_mobile": {
                    'left': '17.3em',
                    'top': '29.8em'
                }
            },

        ]
    },
    "germany": {
        "name": "germany",
        "title": 'Германия',
        'img': '/static/images/maps/germany.jpg',
        'img_mobile': '/static/images/maps_mobile/germany.jpg',
        "items": [
            {
                "id": 1,
                "name": "Кельнский собор",
                "text": "По замыслу кёльнского архиепископа, в 1248 году заложившего первый камень в основание церкви, по размаху она должна была затмить все существующие храмы. Так и вышло: в год завершения строительства высота собора — 157 метров — вывела его на первое место в списке самых больших церквей в мире. C тех пор кёльнское чудо спустилось на пару строк, но по-прежнему обожаемо фотографами.",
                "description": "Которые знают: снимать собор нужно вблизи, не боясь оптических искажений, — вертикальные стены сложатся, что придаст собору еще большую масштабность.",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Кёльн',
                "img": "/static/images/places/germany/germany5.jpg",
                "img_mobile": "/static/images/places_mobile/germany/germany5.jpg",
                "isActive": false,
                "position": {
                    'left': '8.3em',
                    'top': '28.3em'
                },
                "position_mobile": {
                    'left': '4.9em',
                    'top': '26.5em'
                }
            },
            {
                "id": 2,
                "name": "Зал конгрессов в Тиргартен",
                "text": "Из-за вогнутой, похожей на ракушку крыши Зал конгрессов в берлинском парке Тиргартен называют «беременной устрицей». Несмотря на несерьезное прозвище, здание зала — прекрасный образец послевоенного модернизма, который особенно эффектно выглядит при вечерней подсветке",
                "description": "Снимайте его — и его красивое отражение — с аллеи Джона Фостера Даллеса по другую сторону от искусственного пруда.",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Берлин',
                "img": "/static/images/places/germany/germany1.jpg",
                "img_mobile": "/static/images/places_mobile/germany/germany1.jpg",
                "isActive": true,
                "position": {
                    'left': '25.7em',
                    'top': '20.3em'
                },
                "position_mobile": {
                    'left': '19.2em',
                    'top': '20.8em'
                }
            },
            {
                "id": 3,
                "name": "Замок Эльц",
                "text": "Один из самых знаменитых замков Германии стоит на семидесятиметровой скале посреди букового леса. Уникален тем, что в отличие от большинства замков в долине Рейна никогда не подвергался серьезной осаде и потому отлично сохранился — от башен до узкого моста, который ведет к воротам на северной стороне. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Кобленц',
                "img": "/static/images/places/germany/germany2.jpg",
                "img_mobile": "/static/images/places_mobile/germany/germany2.jpg",
                "isActive": false,
                "position": {
                    'left': '10.3em',
                    'top': '32.5em'
                },
                "position_mobile": {
                    'left': '6.5em',
                    'top': '29.5em'
                }
            },
            {
                "id": 4,
                "name": "Квартал Шноорвиртель",
                "text": "В Средние века улица Шнор и прилегающие к ней переулки считались экономическим центром Бремена: здесь, рядом с рекой, по которой сплавляли грузы, селились рыбаки, ремесленники и торговцы. Их дома не сохранились, а вот более поздняя застройка XVI–XVII веков — вполне. ",
                "description": "Снимать ее на закате, когда медовые фасады заливает золотистым светом, одно удовольствие.",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Бремен',
                "img": "/static/images/places/germany/germany4.jpg",
                "img_mobile": "/static/images/places_mobile/germany/germany4.jpg",
                "isActive": false,
                "position": {
                    'left': '13.2em',
                    'top': '17em'
                },
                "position_mobile": {
                    'left': '9em',
                    'top': '18.5em'
                }
            },
            {
                "id": 5,
                "name": "Зеллинский пирс",
                "text": "Красивый причал, уходящий в изумрудное Балтийское море почти на 400 метров, — главный сюжет открыток с курортного острова Рюген. К пирсу ведет настил, который переходит в длинную деревянную лестницу. ",
                "description": "Если снимать причал с ее верхней площадки, в кадр поместится еще и кусочек пляжа со знаменитыми плетеными креслами, защищающими купальщиков от северного ветра. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Рюген',
                "img": "/static/images/places/germany/germany3.jpg",
                "img_mobile": "/static/images/places_mobile/germany/germany3.jpg",
                "isActive": false,
                "position": {
                    'left': '25.8em',
                    'top': '10.2em'
                },
                "position_mobile": {
                    'left': '19.2em',
                    'top': '13.6em'
                }
            },
        ]
    },
    "greece": {
        "name": "greece",
        "title": 'Греция',
        'img': '/static/images/maps/greece.jpg',
        'img_mobile': '/static/images/maps_mobile/greece.jpg',
        "items": [
            {
                "id": 1,
                "name": "Парфенон",
                "text": "Главный храм афинского акрополя и самый известный из памятников Древней Греции был сохранным до 1687 года, когда во время венециано-турецкой войны прямое попадание бомбы разрушило его центральную часть. Современное состояние храма — результат многолетней кропотливой реставрации. ",
                "description": "Сегодня лучше всего выглядит западный фасад, восстановленный в начале десятилетия, — именно с этой стороны Парфенон любят снимать фотографы. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Афины',
                "img": "/static/images/places/greece/greece4.jpg",
                "img_mobile": "/static/images/places_mobile/greece/greece4.jpg",
                "isActive": false,
                "position": {
                    'left': '20.6em',
                    'top': '30.6em'
                },
                "position_mobile": {
                    'left': '14.9em',
                    'top': '28.3em'
                }
            },
            {
                "id": 2,
                "name": "Город Ия",
                "text": "Ия — тот самый ослепительно-белый город на северо-западе Санторини, чьи открыточные красоты принесли острову любовь туристов и фотографов. Последние знают, что Ия хорош во всех ракурсах, но особенно ослепительны виды залива Аммуди на западе курорта: таких закатов больше нет нигде в Греции. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Санторини',
                "img": "/static/images/places/greece/greece1.jpg",
                "img_mobile": "/static/images/places_mobile/greece/greece1.jpg",
                "isActive": true,
                "position": {
                    'left': '28.5em',
                    'top': '41.3em'
                },
                "position_mobile": {
                    'left': '21.5em',
                    'top': '36em'
                }
            },
            {
                "id": 3,
                "name": "Монастырь Великий Метеор",
                "text": "В переводе с греческого «Метеоры» значит «парящие в воздухе» — именно такое впечатление производят древние сталагмитовые скалы в горах Фессалии. В XIV–XV веках на их вершинах были построены монастыри, главным из которых считается Мегала-Метеора, или Великий Метеор, — храм, взирающий на зеленую долину с высоты 613 метров",
                "description": "Снимать его лучше всего с обзорной площадки другого монастыря, например, Святого Николая Анапавсаса. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Каламбака',
                "img": "/static/images/places/greece/greece2.jpg",
                "img_mobile": "/static/images/places_mobile/greece/greece2.jpg",
                "isActive": false,
                "position": {
                    'left': '10.8em',
                    'top': '18.7em'
                },
                "position_mobile": {
                    'left': '6.5em',
                    'top': '19.5em'
                }
            },
            {
                "id": 4,
                "name": "Мыс Драстис",
                "text": "Огромный утес из светлого песчаника на северо-западе Корфу, примерно в часе езды от островной столицы Керкиры, имеет нежные и обтекаемые, как будто пластилиновые формы. Камера их любит: ближе к вечеру, когда приходит мягкий золотистый свет, камни Драстиса напоминают меловые скалы Дувра — правда, в Великобритании не бывает такого лазурного моря. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Корфу',
                "img": "/static/images/places/greece/greece3.jpg",
                "img_mobile": "/static/images/places_mobile/greece/greece3.jpg",
                "isActive": false,
                "position": {
                    'left': '2.4em',
                    'top': '19.5em'
                },
                "position_mobile": {
                    'left': '-.1em',
                    'top': '20em'
                }
            },
            {
                "id": 5,
                "name": "Порт Хора",
                "text": "Лучшие и самые узнаваемые фото Миконоса сделаны в столице острова: ветряные мельницы, круглосуточные рыбные рестораны, торговые улицы с пестрыми лавками керамики и пряностей — Хора обаятельна и по-столичному деловита. Но особенно хорош ее старый порт — квартал белоснежных домиков с бирюзовыми ставнями и балконами, осевших на камнях у самой воды. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Миконос',
                "img": "/static/images/places/greece/greece5.jpg",
                "img_mobile": "/static/images/places_mobile/greece/greece5.jpg",
                "isActive": false,
                "position": {
                    'left': '28em',
                    'top': '34.4em'
                },
                "position_mobile": {
                    'left': '21.2em',
                    'top': '30.8em'
                }
            }
        ]
    },
    "israel": {
        "name": "israel",
        "title": 'Израиль',
        'img': '/static/images/maps/israel.jpg',
        'img_mobile': '/static/images/maps_mobile/israel.jpg',
        "items": [
            {
                "id": 1,
                "name": "Стена Плача",
                "text": "К важнейшей иудейской святыне следует относиться с уважением — например, не поворачиваться к древней кладке спиной и не мешать людям, пришедшим помолиться. ",
                "description": "Чтобы сделать хороший снимок и никого при этом не потревожить, можно подняться на одну из обзорных площадок в Еврейском квартале, вход в который — Мусорные ворота — находится прямо напротив Стены. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Иерусалим',
                "img": "/static/images/places/israel/israel5.jpg",
                "img_mobile": "/static/images/places_mobile/israel/israel5.jpg",
                "isActive": false,
                "position": {
                    'left': '22.7em',
                    'top': '21.4em'
                },
                "position_mobile": {
                    'left': '15.4em',
                    'top': '24.5em'
                }
            },
            {
                "id": 2,
                "name": "Порт Яффа",
                "text": "Яффа — один из старейших приморских городов в мире: здешнему красно-золотистому песчаниковому порту более трех тысяч лет. Последний уже давно работает не стоянкой судов, а главной городской достопримечательностью: наймите лодку и сфотографируйте его единственно правильным способом — с моря. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Тель-Авив',
                "img": "/static/images/places/israel/israel4.jpg",
                "img_mobile": "/static/images/places_mobile/israel/israel4.jpg",
                "isActive": false,
                "position": {
                    'left': '18em',
                    'top': '18.1em'
                },
                "position_mobile": {
                    'left': '12.5em',
                    'top': '22em'
                }
            },
            {
                "id": 3,
                "name": "Красный каньон",
                "text": "Главное геологическое чудо Израиля — Красный каньон — находится всего в 15 километрах от Эйлата. Название не воздает ему должное: в разное время суток формирующие его песчаники имеют разный оттенок — от оранжевого до льдисто-голубого. Глубина ущелья достигает 30 метров, но спуститься на дно можно с помощью металлических скоб в стенах каньона. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Эйлат',
                "img": "/static/images/places/israel/israel2.jpg",
                "img_mobile": "/static/images/places_mobile/israel/israel2.jpg",
                "isActive": false,
                "position": {
                    'left': '19.9em',
                    'top': '47.3em'
                },
                "position_mobile": {
                    'left': '13.6em',
                    'top': '41em'
                }
            },
            {
                "id": 4,
                "name": "Мертвое море",
                "text": "В курортном районе Эйн-Бокек сосредоточено большинство отелей и грязелечебниц Мертвого моря: практически все фотографии, на которых довольные люди с газетами и коктейлями парят в воде, как поплавки, сделаны здесь. Главное — не нахлебаться горькой от соли воды в процессе съемки, уж очень она невкусная. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Эйн-Бокек',
                "img": "/static/images/places/israel/israel3.jpg",
                "img_mobile": "/static/images/places_mobile/israel/israel3.jpg",
                "isActive": false,
                "position": {
                    'left': '23.6em',
                    'top': '28.5em'
                },
                "position_mobile": {
                    'left': '16.4em',
                    'top': '28.6em'
                }
            },
            {
                "id": 5,
                "name": "Бахайские сады",
                "text": "Знаменитый парк в Хайфе расположен на девятнадцати террасах, которые сбегают к побережью залива эффектным километровым каскадом и заканчиваются у мавзолея Баба —основателя бахайской веры. Суть религиозной доктрины бахаев состоит в стремлении к упорядоченности, и фото в их садах хочется делать соответствующие — например, стоя на вершине садовой лестницы и любуясь идеальной симметрией террас. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Хайфа',
                "img": "/static/images/places/israel/israel1.jpg",
                "img_mobile": "/static/images/places_mobile/israel/israel1.jpg",
                "isActive": true,
                "position": {
                    'left': '20em',
                    'top': '9.6em'
                },
                "position_mobile": {
                    'left': '14em',
                    'top': '16.2em'
                }
            },
        ]
    },
    "tailandia": {
        "name": "tailandia",
        "title": 'Тайланд',
        "city": 'Париж',
        'img': '/static/images/maps/tailandia.jpg',
        'img_mobile': '/static/images/maps_mobile/tailandia.jpg',
        "items": [
            {
                "id": 1,
                "name": "Храм Ват-Пхо",
                "text": "Старинный, XII века постройки, храм на территории Королевского дворца прославился благодаря известной статуе Будды в ожидании нирваны, его крупнейшему лежачему изображению. ",
                "description": "Лучше всего снимать Будду, встав у его ступней, — так в кадр поместится все длинное золотистое тело Просветленного. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Бангкок',
                "img": "/static/images/places/tailandia/tailandia5.jpg",
                "img_mobile": "/static/images/places_mobile/tailandia/tailandia5.jpg",
                "isActive": false,
                "position": {
                    'left': '15.5em',
                    'top': '26.2em'
                },
                "position_mobile": {
                    'left': '10.8em',
                    'top': '24.9em'
                }
            },
            {
                "id": 2,
                "name": "Бухта Майя-Бэй",
                "text": "В числе первых картинок, которые поисковик выдает по запросу «тайские острова», всегда будет залив Майя — красивейшая мелкая бухта, окруженная высокими скалами. Хорошо здесь все: прозрачная лазурная вода, белый, похожий на тальк песок и длиннохвостые лодки, украшенные цветами и яркими лентами.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'остров Пхи-Пхи-Ле',
                "img": "/static/images/places/tailandia/tailandia1.jpg",
                "img_mobile": "/static/images/places_mobile/tailandia/tailandia1.jpg",
                "isActive": true,
                "position": {
                    'left': '11em',
                    'top': '43em'
                },
                "position_mobile": {
                    'left': '7.1em',
                    'top': '37em'
                }
            },
            {
                "id": 3,
                "name": "Смотровая площадка Джон-Суван",
                "text": "Знаменитая обзорная площадка находится между пляжами Чалок-Бан-Као и Тьен-Ог — в самом сердце острова. Отсюда можно увидеть, что своими очертаниями Ко-Тао, чье название с тайского переводится как «остров черепах», действительно похож на морскую рептилию, которая плывет в бирюзовом море. ",
                "description": "Забраться сюда непросто, но оно того стоит: фото, сделанные на Джон-Суван, выглядят очень впечатляюще. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'остров Тао',
                "img": "/static/images/places/tailandia/tailandia4.jpg",
                "img_mobile": "/static/images/places_mobile/tailandia/tailandia4.jpg",
                "isActive": false,
                "position": {
                    'left': '14.1em',
                    'top': '37.2em'
                },
                "position_mobile": {
                    'left': '9.5em',
                    'top': '33em'
                }
            },
            {
                "id": 4,
                "name": "Национальный парк Дой-Интханон",
                "text": "Парк Дой-Интханон нередко называют «крышей Таиланда»: здесь находится самая высокая гора в стране, окруженная джунглями — поросшими мхом деревьями, густыми зарослями рододендронов и тропическими кустарниками. Эффект оторванности от цивилизации здесь практически стопроцентный — мешают разве что фотографы, обвешанные тяжелыми объективами. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Чиангмай',
                "img": "/static/images/places/tailandia/tailandia2.jpg",
                "img_mobile": "/static/images/places_mobile/tailandia/tailandia2.jpg",
                "isActive": false,
                "position": {
                    'left': '11.9em',
                    'top': '11.4em'
                },
                "position_mobile": {
                    'left': '7.7em',
                    'top': '14.3em'
                }
            },
            {
                "id": 5,
                "name": "Озеро Тхале-Ной",
                "text": "Тхале-Ной, или «Малое море», известно двумя вещами: фантастическим разнообразием птиц и кувшинками цвета фуксии — последних здесь целые поля. Кататься на лодке по озеру приятно в любое время дня, но снимать лучше с утра: к полудню нимфеи закрываются, а птицы разлетаются по гнездам, спасаясь от тропической жары. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Пхаттхалунг',
                "img": "/static/images/places/tailandia/tailandia3.jpg",
                "img_mobile": "/static/images/places_mobile/tailandia/tailandia3.jpg",
                "isActive": false,
                "position": {
                    'left': '14.9em',
                    'top': '44em'
                },
                "position_mobile": {
                    'left': '10.1em',
                    'top': '37.9em'
                }
            }
        ]
    },
    "turkey": {
        "name": "turkey",
        "title": 'Турция',
        'img': '/static/images/maps/turkey.jpg',
        'img_mobile': '/static/images/maps_mobile/turkey.jpg',
        "items": [
            {
                "id": 1,
                "name": "Голубая Мечеть",
                "text": "На форумах путешественников часто пишут, что название мечети не соответствует правде и голубые в ней только изразцы, которые покрывают ее изнутри. Но если попробовать снять мечеть в контровом солнце, когда оно, перевалив за полдень, медленно закатывается над Мраморным морем, ее стены действительно приобретают красивейший голубой оттенок. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Стамбул',
                "img": "/static/images/places/turkey/turkey2.jpg",
                "img_mobile": "/static/images/places_mobile/turkey/turkey2.jpg",
                "isActive": false,
                "position": {
                    'left': '7.5em',
                    'top': '23em'
                },
                "position_mobile": {
                    'left': '4.4em',
                    'top': '22.8em'
                }
            },
            {
                "id": 2,
                "name": "Национальный парк Гереме",
                "text": "Скалистая область в Центральной Турции издавна привлекала людей: здесь встречаются пещерные храмы ранних христиан, а археологи находят следы человеческого присутствия, которые датируются VIII тысячелетием до н.э. Но первые «жильцы» Каппадокии — огромные каменные конусы с базальтовой коркой, похожие на грибы, — появились здесь задолго до нас. ",
                "description": "Особенно эффектно эти образования выглядят из корзины воздушного шара: Каппадокия — главный центр турецкого воздухоплавания. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Каппадокия',
                "img": "/static/images/places/turkey/turkey5.jpg",
                "img_mobile": "/static/images/places_mobile/turkey/turkey5.jpg",
                "isActive": false,
                "position": {
                    'left': '18.5em',
                    'top': '29.2em'
                },
                "position_mobile": {
                    'left': '12.8em',
                    'top': '27.2em'
                }
            },
            {
                "id": 3,
                "name": "Источники Памуккале",
                "text": "Знаменитые белые террасы, расположенные на юго-западе страны, в провинции Денизли, возникли в результате отложения солей из насыщенных кальцием горячих источников. Вода в них считается целебной, но купаться сегодня разрешено только в «бассейне Клеопатры» (доказательств, что в нем плавала царица, конечно, нет). ",
                "description": "Остальные источники можно обойти по специальной туристической тропе — босиком или в бахилах. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Памуккале',
                "img": "/static/images/places/turkey/turkey3.jpg",
                "img_mobile": "/static/images/places_mobile/turkey/turkey3.jpg",
                "isActive": false,
                "position": {
                    'left': '8em',
                    'top': '31.1em'
                },
                "position_mobile": {
                    'left': '4.6em',
                    'top': '28.7em'
                }
            },
            {
                "id": 4,
                "name": "Бухта Кабак-Бэй",
                "text": "Небольшой залив с узкой полоской пляжа регулярно попадает в списки самых красивых бухт Турции. Вполне заслуженно: бирюзовый квадрат воды в Кабаке держат, как ставни, два зеленых, покрытых лесом рукава суши. Получается своеобразное окно в море — смотреться в которое лучше всего с вершины горы над бухтой. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Фетхийе',
                "img": "/static/images/places/turkey/turkey1.jpg",
                "img_mobile": "/static/images/places_mobile/turkey/turkey1.jpg",
                "isActive": true,
                "position": {
                    'left': '7.5em',
                    'top': '34.8em'
                },
                "position_mobile": {
                    'left': '4.3em',
                    'top': '30.8em'
                }
            },
            {
                "id": 5,
                "name": "Монастырь Сумале",
                "text": "По легенде, красивый православный монастырь на крутой скале у Черного моря основали еще в 386 году монахи, прибывшие из Афин с чудотворной иконой Богородицы. В 1923-м монашеская жизнь в Сумеле подошла к концу: после Второй греко-турецкой войны все христиане должны были покинуть северные районы Османской империи и переселиться в Грецию. Монастырь пришел в запустение — тем не менее, учитывая драматические обстоятельства, сохранился он прекрасно.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Трабзон',
                "img": "/static/images/places/turkey/turkey4.jpg",
                "img_mobile": "/static/images/places_mobile/turkey/turkey4.jpg",
                "isActive": false,
                "position": {
                    'left': '27.9em',
                    'top': '23.3em'
                },
                "position_mobile": {
                    'left': '20em',
                    'top': '23em'
                }
            },
        ]
    },
    "oae": {
        "name": "oae",
        "title": 'ОАЭ',
        'img': '/static/images/maps/oae.jpg',
        'img_mobile': '/static/images/maps_mobile/oae.jpg',
        "items": [
            {
                "id": 1,
                "name": "Башня Бурж-Халифа",
                "text": "Сфотографировать самое высокое здание в мире сложно: почти километровый стальной сталагмит помещается в кадр с трудом. Зато со смотровой площадки, которая находится на 148-м этаже башни, открывается лучший вид на Дубай из всех существующих: обязательно выйдите на открытую террасу, где между защитными стеклами есть специальные щели — можно выставить руку со смартфоном и снять небоскребы без бликов от стекла. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Дубай',
                "img": "/static/images/places/oae/oae1.jpg",
                "img_mobile": "/static/images/places_mobile/oae/oae1.jpg",
                "isActive": true,
                "position": {
                    'left': '23em',
                    'top': '24em'
                },
                "position_mobile": {
                    'left': '17.2em',
                    'top': '23.5em'
                }
            },
            {
                "id": 2,
                "name": "Мечеть Шейха Зайда",
                "text": "В эту мечеть, одну из шести самых больших в мире, бесплатно пускают всех ценителей исламской архитектуры. Действительно, здесь есть на что посмотреть: здание, украшенное сотней куполов, окружено садами и искусственными озерами. ",
                "description": "Эффектнее всего мечеть выглядит по вечерам, когда включается подсветка: арки заливает золотым, а купола — голубым сиянием.",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Абу-Даби',
                "img": "/static/images/places/oae/oae2.jpg",
                "img_mobile": "/static/images/places_mobile/oae/oae2.jpg",
                "isActive": false,
                "position": {
                    'left': '18.5em',
                    'top': '29.3em'
                },
                "position_mobile": {
                    'left': '13.3em',
                    'top': '27.2em'
                }
            },
            {
                "id": 3,
                "name": "Пустыня Руб-аль-Хали",
                "text": "По-арабски «руб-эль-хали» — «место, где ничего нет». На деле же в пустыне, занимающей треть Аравийского полуострова, много прекрасного: старинные арабские форты, пальмовые оазисы, стада золотистых ориксов и волнистые гряды песчаных дюн. Сцены из знаменитой звездной саги, которые происходят на пустынной планете Джакку, снимали в Руб-эль-Хали: в этих песках тонет космический корабль, здесь же живет искательница металлолома, первая женщина-джедай в истории франшизы.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": '-',
                "img": "/static/images/places/oae/oae5.jpg",
                "img_mobile": "/static/images/places_mobile/oae/oae5.jpg",
                "isActive": false,
                "position": {
                    'left': '2.5em',
                    'top': '35em'
                },
                "position_mobile": {
                    'left': '0.2em',
                    'top': '31em'
                }
            },
            {
                "id": 4,
                "name": "Оазис Аль-Айн",
                "text": "От Абу-Даби Аль-Айн отделяют полтора часа езды на машине, а кажется, что тысячи лет: финиковые пальмы в здешнем оазисе посреди пустыни до сих пор орошают с помощью древней ирригационной системы афладж — красивых каменных каналов, по которым вода доставляется под воздействием силы тяжести. ",
                "description": "Зеленый свет в кронах, солнечные блики от ручьев, старинная кладка — Аль-Айн создан для тревел-фотографии. ",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Аль-Айн',
                "img": "/static/images/places/oae/oae3.jpg",
                "img_mobile": "/static/images/places_mobile/oae/oae3.jpg",
                "isActive": false,
                "position": {
                    'left': '26em',
                    'top': '31.4em'
                },
                "position_mobile": {
                    'left': '19.5em',
                    'top': '28.7em'
                }
            },
            {
                "id":5,
                "name": "Остров Сир-Бани-Яс",
                "text": "Один из немногих естественных островов в Эмиратах, Сир-Бани-Яс называют арабским Ноевым ковчегом: в 1971 году шейх Зайд объявил бóльшую часть его территории заповедником дикой природы. На сегодняшний день здешняя система искусственного орошения считается сложнейшей в мире: вода подается отдельно к каждому из восьми миллионов деревьев, между которыми бродят газели, ориксы, жирафы, страусы и даже гепарды. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": '-',
                "img": "/static/images/places/oae/oae4.jpg",
                "img_mobile": "/static/images/places_mobile/oae/oae4.jpg",
                "isActive": false,
                "position": {
                    'left': '9.2em',
                    'top': '30em'
                },
                "position_mobile": {
                    'left': '5.4em',
                    'top': '27.8em'
                }
            },

        ]
    },
    "korea": {
        "name": "korea",
        "title": 'Корея',
        "city": 'Париж',
        'img': '/static/images/maps/korea.jpg',
        'img_mobile': '/static/images/maps_mobile/korea.jpg',
        "items": [
            {
                "id": 1,
                "name": "Улица Инсадон",
                "text": "Cтоличная торговая улица — настоящая выставка народных достижений и ремесел: здесь держат лавки чайные мастера, прорицатели и торговцы традиционными южнокорейскими сладостями, открывают галереи художники-керамисты и ювелиры, проводят фестивали различные ассоциации уличной еды. Пестрые вывески всех этих предприятий сливаются в узнаваемый инсадонский узор, который очень хочется забрать с собой — на фотографиях. Сделать это легко: используйте в съемке естественные линии улицы как диагонали, направляющие взгляд зрителя по снимку. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Сеул',
                "img": "/static/images/places/korea/korea4.jpg",
                "img_mobile": "/static/images/places_mobile/korea/korea4.jpg",
                "isActive": false,
                "position": {
                    'left': '14.9em',
                    'top': '19.4em'
                },
                "position_mobile": {
                    'left': '10.3em',
                    'top': '20.1em'
                }
            },
            {
                "id": 2,
                "name": "Пляж Кваналли",
                "text": "Кваналли, пожалуй, самый знаменитый пляж Южной Кореи: кроме чаек, живописного рыбного рынка и плавучего настила, на котором можно позагорать, здесь есть своя достопримечательность — красивый подвесной мост Кванан, второй по длине в стране. Конструкция оборудована подсветкой, которая меняет цвет в зависимости от времени суток, дня недели и даже сезона.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Пусан',
                "img": "/static/images/places/korea/korea2.jpg",
                "img_mobile": "/static/images/places_mobile/korea/korea2.jpg",
                "isActive": false,
                "position": {
                    'left': '24.3em',
                    'top': '35em'
                },
                "position_mobile": {
                    'left': '18.1em',
                    'top': '31.3em'
                }
            },
            {
                "id": 3,
                "name": "Скала Йондуам",
                "text": "Чтобы разглядеть в морской скале дракона, сходство с которым ей приписывают путеводители, приходится подключить фантазию. Но то в дневное время, а вот на закате, когда уходит лишний рельеф и остается лишь темный силуэт на фоне пламенеющего неба, скала Йондуам превращается в легендарного змея — красивого и устрашающего. ",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'остров Чеджу',
                "img": "/static/images/places/korea/korea3.jpg",
                "img_mobile": "/static/images/places_mobile/korea/korea3.jpg",
                "isActive": false,
                "position": {
                    'left': '12.9em',
                    'top': '45.4em'
                },
                "position_mobile": {
                    'left': '8.6em',
                    'top': '38.7em'
                }
            },
            {
                "id": 4,
                "name": "Чайные плантации",
                "text": "Почти половину корейского чая выращивают на плантациях вокруг уездного города Посон. Здесь, на плодородном юге страны, часто снимают исторические фильмы: уходящие за горизонт ряды чайных кустов, рощи криптомерий и сосен, присыпанные песком дорожки и аллеи — за последние сто лет знаменитые плантации практически не изменились.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Посон',
                "img": "/static/images/places/korea/korea5.jpg",
                "img_mobile": "/static/images/places_mobile/korea/korea5.jpg",
                "isActive": false,
                "position": {
                    'left': '16.2em',
                    'top': '37.2em'
                },
                "position_mobile": {
                    'left': '11.3em',
                    'top': '33em'
                }
            },
            {
                "id": 5,
                "name": "Крепость Намхансансон",
                "text": "Несколько лет назад горную крепость к юго-востоку от Сеула, которая была построена как временная столица в мятежные времена, включили в Список всемирного наследия ЮНЕСКО. Сегодня здесь, как и прежде, ищут покоя и спасения от большого города: с крепостных стен открываются чудесные виды леса, а из беседки Суочжандэ, наивысшей точки внутри крепости, — панорамы Инчхона и Сеула.",
                "description": "",
                "address": "Pont Alexandre III, 75008 Paris, Франция",
                "city": 'Соннам',
                "img": "/static/images/places/korea/korea1.jpg",
                "img_mobile": "/static/images/places_mobile/korea/korea1.jpg",
                "isActive": true,
                "position": {
                    'left': '15.2em',
                    'top': '21.1em'
                },
                "position_mobile": {
                    'left': '11em',
                    'top': '21.1em'
                }
            },
        ]
    },
}




// WEBPACK FOOTER //
// ./src/tools/Country.js